import AsyncStorage from '@react-native-async-storage/async-storage';
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import PersistenceRegistry from '../base/redux/PersistenceRegistry';
import ReducerRegistry from '../base/redux/ReducerRegistry';
const KEY_NAME = 'features/vmp-user';
const initialState = {
    token: '',
    refreshToken: '',
    username: '',
    saveLogin: false
};
const vmpUserSlice = createSlice({
    name: KEY_NAME,
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.token = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
            state.username = action.payload.username;
            state.name = action.payload.name;
            state.bgrColor = action.payload.bgrColor;
            state.email = action.payload.email;
            state.dateOfBirth = action.payload.dateOfBirth;
            state.displayName = action.payload.displayName;
            state.gender = action.payload.gender;
            state.groupId = action.payload.groupId;
            state.id = action.payload.id;
            state.images = action.payload.images;
            state.lang = action.payload.lang;
            state.type = action.payload.type;
            state.verifyMail = action.payload.verifyMail;
            state.isPhoneVerify = action.payload.isPhoneVerify;
            state.saveLogin = action.payload.saveLogin;
        },
        setTokens: (state, action) => {
            state.token = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
        },
        setRefreshToken: (state, action) => {
            state.token = action.payload;
        },
        removeUser: (state) => {
            state.token = '';
            state.refreshToken = '';
            state.username = '';
            state.name = '';
            state.bgrColor = '';
            state.email = '';
            state.dateOfBirth = '';
            state.displayName = '';
            state.gender = '';
            state.groupId = '';
            state.id = undefined;
            state.images = '';
            state.lang = '';
            state.type = '';
            state.verifyMail = '';
            state.isPhoneVerify = undefined;
            state.saveLogin = false;
        },
        updateDisplayName: (state, action) => {
            state.displayName = action.payload;
        }
    }
});
const userPersistConfig = {
    key: KEY_NAME,
    storage: AsyncStorage // Use AsyncStorage for persistence
};
const pvmpReducer = persistReducer(userPersistConfig, vmpUserSlice.reducer);
ReducerRegistry.register(KEY_NAME, pvmpReducer);
PersistenceRegistry.register(KEY_NAME, pvmpReducer);
export const { setUser, setTokens, setRefreshToken, removeUser, updateDisplayName } = vmpUserSlice.actions;
export default pvmpReducer;
